<template>
  <v-radio-group
    class="ma-0 pa-0"
    v-model="selectedRadio"
    :hide-details="'auto'"
    :rules="rules"
  >
    <v-radio
      v-for="option in options"
      class="mt-0 mb-4 pa-0"
      color="blue"
      :key="option.id"
      :label="option.name"
      :value="option.id"
      :disabled="loading"
      @click.capture.stop="handleChange(option.id)"
    >
    </v-radio>

    <LinkedFindingWarningDialog
      :show="openWarningModal"
      @cancel="openWarningModal = false"
      @continue="handleContinue"
    />
  </v-radio-group>
</template>

<script>
import LinkedFindingWarningDialog from './LinkedFindingWarning.vue'

export default {
  name: 'Radios',

  components: {
    LinkedFindingWarningDialog,
  },

  data() {
    return {
      selectedRadio: this.response,
      selectedRadioBeforeModal: '',
      openWarningModal: false,
    }
  },

  computed: {
    hasRequiredFinding() {
      return (
        this.options.filter(item => item.id === this.selectedRadio)[0]
          ?.requiresFinding ?? false
      )
    },
  },

  props: {
    options: {
      type: Array,
      required: true,
    },
    response: {
      type: String,
      required: false,
    },
    loading: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
    hasFinding: Boolean,
  },

  methods: {
    handleChange(val) {
      if (this.hasFinding) {
        this.selectedRadioBeforeModal = val
        this.openWarningModal = true
      } else {
        this.selectedRadio = val
        this.$emit('change', val)
      }
    },

    handleContinue() {
      this.selectedRadio = this.selectedRadioBeforeModal
      this.$emit('handleWarningContinue', this.selectedRadioBeforeModal)
      this.openWarningModal = false
    },
  },
}
</script>
